/*
 * @Description: 
 * @Author: 饶超
 * @Date: 2022-04-16 16:03:16
 * @LastEditors: 饶超
 * @LastEditTime: 2024-07-21 13:52:12
 */
import request from '@/Utils/request.js';
// 获取权限下考生报名信息列表
export function GetExaminerHaveExamFromList(params) {
  return request({
    url: '/api/Examiner/GetExaminerHaveExamFromList',
    params: params,
    method: 'get',
  });
}

// 获取报名信息下的评审信息
export function GetExamFormReviewInfo(params) {
  return request({
    url: '/api/Examiner/GetExamFormReviewInfo',
    params: params,
    method: 'get',
  });
}

// 考官提交评审信息
export function SubmitExaminerReview(data) {
  return request({
    url: '/api/Examiner/SubmitExaminerReview',
    data: data,
    method: 'post',
  });
}
// 考官修改评语
export function ChangeExaminerReview(data) {
  return request({
    url: '/api/Examiner/ChangeExaminerReview',
    data: data,
    method: 'post',
  });
}
// 获取考官考场
export function GetExaminerExamTiemList(params) {
  return request({
    url: '/api/Examiner/GetExaminerExamTiemList',
    params: params,
    method: 'get',
  });
}


// 获取所有考场分组信息
export function GetExamTimeMajors(params) {
  return request({
    url: '/api/Examiner/GetExamTimeMajors',
    params: params,
    method: 'get',
  });
}

// 获取报名信息下的听力考试评审信息
export function GetExamFormMusicTheoryReviewInfo(params) {
  return request({
    url: '/api/Examiner/GetExamFormMusicTheoryReviewInfo',
    params: params,
    method: 'get',
  });
}

// 重置考试评测记录
export function ResetReview(params) {
  return request({
    url: '/api/Examiner/ResetReview',
    params: params,
    method: 'post',
  });

}

// 获取指定试题配置
export function GetSpecifiedExamPatterns(params) {
  return request({
    url: '/api/Examiner/GetSpecifiedExamPatterns',
    method: 'get',
    params: params
  })
}

// 考官提交评审信息
export function SubmitOfflineExaminerReview(data, params) {
  return request({
    url: '/api/Examiner/SubmitOfflineExaminerReview',
    data: data,
    params: params,
    method: 'post',
  });
}